import React from 'react';
import styled from 'styled-components';

import NavItem, { Props as NavItemProps } from './NavItem';
import { MenuEditorDnDItem } from '../components/MenuEditorDnDContext';

type Props = NavItemProps & {
  canDrop: (itemId: string) => boolean;
  menuId: string;
};

const StyledMenuEditorDnDItem = styled(MenuEditorDnDItem)`
  display: block;
  margin-inline-end: -8px;
  margin-inline-start: -8px;
`;

const ITEMS_WITH_NO_CATEGORY_NAVITEM_ID = 'ITEMS_WITH_NO_CATEGORY_NAVITEM_ID';

const ItemsWithNoCategoryNavItem = ({ canDrop, name, transient, ...rest }: Props) => {
  return (
    <StyledMenuEditorDnDItem
      id={ITEMS_WITH_NO_CATEGORY_NAVITEM_ID}
      disabled={{
        draggable: true,
      }}
      data={{
        type: 'DND_NAVIGATION_NO_CATEGORY',
        shrinkOverlayTypes: ['DND_EDITOR_SINGLE_ITEM'],
      }}
    >
      {({ over, active }) => (
        <NavItem
          {...rest}
          name={name}
          dropActive={
            over?.id === ITEMS_WITH_NO_CATEGORY_NAVITEM_ID &&
            canDrop(over.id) &&
            active?.data.current?.type === 'DND_EDITOR_SINGLE_ITEM'
          }
          transient={transient}
        />
      )}
    </StyledMenuEditorDnDItem>
  );
};

export default ItemsWithNoCategoryNavItem;
